import React from 'react'
import PropTypes from 'prop-types'
import CatalogoAgregarArticulo from '../../components/Catalogo/CatalogoAgregarArticulo'
import * as catalogoActions from '../../reducers/catalogoReducer/actions'
import * as articuloActions from '../../reducers/articuloReducer/actions'
import * as rubrosActions from '../../reducers/rubrosReducer/actions'
import { catalogoDataSelector, publicadosSelector } from '../../selectors/catalogoSelector'
import { articuloDataSelector } from '../../selectors/articuloSelector'
import { rubrosDataSelector } from '../../selectors/rubrosSelector'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Notification from '../../components/Common/notification'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import { instalacionSelector, usuarioSelector, resultadoAutenticacionSelector } from '../../selectors/sessionSelector'
import { isNaN } from 'lodash'

class CatalogoAgregarArticulosContainer extends React.Component {

    constructor(props) {
        super(props)




        this.state = {
            imagenesCargadas: false,
            open: false, //Open modal busqueda avanzada
            openNewModal: false, // Open modal nuevo articulo
            agregandoNuevosArticulos: false,
            mostrarTitleBar: true,

            //Estos son para instanciar de antemano los combos. El ultimo si es True, va derecho al componente de articulo nuevo.
            superRubroUnico: false,
            rubroUnico: false,
            ambosUnicos: false,

            //Valores para el manejo de errores en el modal de creacion
            superRubroValidoModal: true,
            rubroValidoModal: true,

            //Filtros
            filtros: {
                idSuperRubro: 0,
                idRubro: 0,
                idSubRubro: 0,
                Nombre: '',
                Codigo: ''
            },

            //paginacion
            page: 1,
            pagesize: 40,
            hasmorearticulos: true,
            searchString: '',  //almacena el valor de busqueda
            searching: false,
            usuarioCargado: false
        }


        this.props.sagaGetSubRubros(0, null, true);
        this.props.sagaGetRubros(null, true, true);
        this.props.sagaGetSuperRubros()
        this.props.sagaInitialStateArticulo()
        let search = ''
        let payload = {};
        payload.page = this.state.page;
        payload.pagesize = this.state.pagesize;
        payload.idCatalogo = this.props.match.params.idCatalogo;
        payload.showLoading = false;


        let payloadCatalogo = {};
        payloadCatalogo.idCatalogo = this.props.match.params.idCatalogo;

        this.props.sagaGetCatalogoByName(payload);


        this.props.sagaGetListadoArticulosAusentesEnCatalogo(payload);



        //verifico si el usuario está logueado
        if (this.props.usuario === undefined) {


            this.props.sagaFetchUsuarioLogeado();
        }
        //Limpiamos el reductor del articulo completo para evitar que se muestre un articulo erroneo cuando se vuelve atras y se selecciona otro para editar
        this.props.setArticuloCompleto(undefined)

    }


    handleOnAgregarArticulos = () => {

        this.setState({
            agregandoNuevosArticulos: true
        });



        this.props.history.push('/Catalogo/catalogoEdicion/' + this.props.data.catalogos[0].idCatalogo + '/agregarArticulos')
    }
    handleOnNewButton = () => {
    }
    handleOnSearch = (searchString) => {
        let payload = {}
        if (searchString.length < 255) {
            payload.page = 1;
            payload.pagesize = this.state.pagesize;
            payload.Codigo = "";
            payload.Nombre = "";
            payload.idCatalogo = this.props.match.params.idCatalogo;
            var codigo = Number.parseInt(searchString);
            if (Number.isNaN(codigo)) {
                payload.Nombre = searchString;
            }
            else {
                payload.Codigo = searchString;
            }
            this.setState({
                page: 1,
                searchString: searchString,
                hasmorearticulos: true
            })
            this.props.sagaInitialStateArticulo();
            this.props.sagaGetListadoArticulosAusentesEnCatalogo(payload);
        }
        else {
            Notification.showError('Exceso de caracteres. Revise la búsqueda.')
        }

    }


    fetchMoreArticulos = () => {
        if (this.props.dataArticulos.listadoArticulo !== undefined) {
            if (this.state.searching === false) {
                let payload = this.state.filtros
                let nextpage = this.state.page + 1;
                if (nextpage <= this.props.dataArticulos.listadoArticulo.totalPaginas) {
                    payload.Callback = () => {
                        let filtroAux = { ...this.state.filtros }
                        filtroAux.idSuperRubro = this.state.superRubroUnico ? 1 : 0
                        this.setState({
                            open: false,
                            filtros: filtroAux,
                            searching: false
                        })
                    }
                    payload.page = nextpage;
                    payload.pagesize = this.state.pagesize;
                    if (this.state.searchString != '')
                        payload.Nombre = this.state.searchString;
                    payload.idCatalogo = this.props.match.params.idCatalogo;
                    this.setState({
                        searching: true
                    })

                    this.props.sagaGetListadoEntradas(payload);
                    let mas = false;
                    if ((nextpage + 1) < this.props.dataArticulos.listadoArticulo.totalPaginas)
                        mas = true;
                    this.setState({
                        page: nextpage,
                        hasmorearticulos: mas
                    })
                }
                else {
                    this.setState({
                        hasmorearticulos: false
                    })
                }

            }
        }
    }
    /*
    fetchMoreArticulos = () => {        
        if (this.props.dataArticulos.listadoArticulo !== undefined)
        {            
            if (this.state.searching == false)
            {
                let payload  = this.state.filtros
                let nextpage = this.state.page + 1;
                if (nextpage <= this.props.dataArticulos.listadoArticulo.totalPaginas)
                {                
                    payload.Callback = () => {
                        let filtroAux = {...this.state.filtros}
                        filtroAux.idSuperRubro = this.state.superRubroUnico ? 1: 0
                        this.setState({
                            open:false,
                            filtros : filtroAux, 
                            searching : false
                        })
                    }    
                    payload.page = nextpage;
                    payload.pagesize = this.state.pagesize;
                    if (this.state.searchString != '')
                        payload.Nombre = this.state.searchString;
                    payload.idCatalogo=this.props.match.params.idCatalogo; 
                    this.setState({
                        searching: true
                    })                       
                                 
                    this.props.sagaGetListadoArticulosAusentesEnCatalogo(payload);
                    let mas = false;
                    if ((nextpage + 1) < this.props.dataArticulos.listadoArticulo.totalPaginas)      
                        mas = true;
                    this.setState({
                        page : nextpage, 
                        hasmorearticulos : mas
                    })        
                }
                 
            }
        }
    }
*/
    getImgArticulo = (idArticulo) => {
        let flag = true

        if (this.props.match.params.getCatalogo !== "true" && this.props.imagenesArticulos !== undefined) {
            this.props.imagenesArticulos.forEach((img) => {
                if (img.idArticulo === idArticulo) {
                    flag = false
                }
            })
        }
        if (flag) {
            let payload = {}
            payload.idArticulo = idArticulo
            payload.listaCompleta = false
            this.props.sagaGetImagenesListadoArticulos(payload)
        }

    }

    handleNombreArticulo = (e) => {
        let filtroAux = { ...this.state.filtros }

        filtroAux.Nombre = e.target.value

        this.setState({
            filtros: filtroAux
        })
    }

    handleCodigoArticulo = (e) => {
        let filtroAux = { ...this.state.filtros }

        filtroAux.Codigo = e.target.value

        this.setState({
            filtros: filtroAux
        })
    }


    validarNombre = () => {
        if (this.state.filtros.Nombre.length > 255) {
            return false
        }
        return true
    }

    validarCodigo = () => {
        if (this.state.filtros.Codigo.length > 255) {
            return false
        }
        return true
    }

    validar = () => {
        if (this.state.filtros.Nombre.length > 255) {
            return false
        }
        if (this.state.filtros.Codigo.length > 255) {
            return false
        }

        return true
    }
    componentDidUpdate = () => {

        if (this.props.data.catalogoCompleto !== undefined && this.state.imagenesCargadas === false) {
            this.props.setImagenesActualizadas(true)

            this.setState({
                imagenesCargadas: true,
                catalogo: this.props.data.catalogoCompleto
            })
        }

    }

    componentWillReceiveProps(nextProps) {





        if (nextProps.data.catalogoCompleto !== this.props.data.catalogoCompleto) {
            this.setState({
                imagenesCargadas: true,
                showPublicarButton: nextProps.data.catalogoCompleto !== undefined && nextProps.data.catalogoCompleto.fechaPublicacion === null, //publicar esta habilitado si la fecha de publcacion del catalogo es nula
                showOcultarButton: nextProps.data.catalogoCompleto !== undefined && nextProps.data.catalogoCompleto.fechaPublicacion !== null, //ocultar esta habilitado si la fecha de publcacion del catalogo NO es nula
                showTrasladarButton: nextProps.data.catalogoCompleto !== undefined && nextProps.data.catalogoCompleto.fechaPublicacion === null, //trasladar esta habilitado si la fecha de publcacion del catalogo es nula
                catalogo: nextProps.data.catalogoCompleto,
                update: true
            })
        }


    }

    handleOnClickAgregarArticulo = (event, articulo) => {

        let payload = {}
        payload.idArticulo = articulo;
        payload.idCatalogo = this.props.match.params.idCatalogo;
        payload.usuario = this.props.usuario.id;
        payload.callback = () => {


        }


        this.props.sagaSaveAgregarArticuloEntrada(payload);
    }
    getImagenes = () => {

        let catalogoCompleto = this.props.data.catalogoCompleto
        // itero los rubros
        for (var i = 0; i < catalogoCompleto.listaRubros.length; i++) {
            let rubro = catalogoCompleto.listaRubros[i]

            // itero los subrubros
            for (var j = 0; j < rubro.listaSubRubros.length; j++) {
                let subrubro = rubro.listaSubRubros[j]

                // itero los artículos
                for (var k = 0; k < subrubro.listaArticulos.length; k++) {
                    let articulo = subrubro.listaArticulos[k]

                    // busco la primera imagen del artículo
                    if (articulo.listaImagenesArticulos === undefined) {
                        let payload = {}
                        payload.idArticulo = articulo.idArticulo
                        payload.listaCompleta = false

                        this.props.sagaGetImagenesArticulo(payload)
                    }
                }
            }
        }


    }




    getImgArticulo = (idArticulo) => {
        let flag = true
        if (this.props.imagenesArticulos !== undefined) {
            this.props.imagenesArticulos.forEach((img) => {
                if (img.idArticulo === idArticulo) {
                    flag = false
                }
            })
        }

        if (flag) {
            let payload = {}
            payload.idArticulo = idArticulo
            payload.listaCompleta = false

            this.props.sagaGetImagenesArticulo(payload)
        }

    }

    getImgArticuloParams = (idArticulo) => {
        let payload = {}
        payload.idArticulo = parseInt(idArticulo)
        payload.listaCompleta = false

        this.props.sagaGetImagenesArticulo(payload)
    }

    handleOnClickPublicar = () => {
        //Aqui va la validación para ver si es catalogo unico o que.
        this.setState({
            showDialogPublicar: true
        })
    }

    handleOnClickTrasladar = () => {
        if (this.validarStock() && this.validarPublicados()) {
            this.setState({
                showDialogTrasladar: true
            })
        }
        else {
            if (this.validarStock() === false) {
                this.setState({
                    stockDisponible: false
                })
                Notification.showError("No hay Articulos con Stock disponible para trasladar")
            }
            else {
                if (this.validarPublicados() === false) {
                    this.setState({
                        catalogosPublicados: false
                    })

                    Notification.showError("No hay Catálogos publicados hacia donde trasladar")
                }
            }
        }
    }

    validarStock = () => {
        let valido = false
        this.props.data.catalogoCompleto.listaRubros.map((rubroItem, rubroIndex) => {
            return (
                rubroItem.listaSubRubros.map((subrubroItem, subrubroIndex) => {
                    return (
                        subrubroItem.listaArticulos.map((articuloItem, artiuloIndex) => {
                            if (articuloItem.catalogoEntradaActivo == true && articuloItem.stockDisponible == true) {
                                valido = true
                            }
                        })
                    )
                })
            )
        })

        return valido
    }

    validarPublicados = () => {
        let valido = false
        if (this.props.dataPublicados.data.length > 0) {
            valido = true
        }

        return valido
    }

    handleOnClickOcultar = () => {
        this.setState({
            showDialogOcultar: true
        })
    }

    handleOnClickBorrar = () => {
        this.setState({
            showDialogBorrar: true
        })
    }

    handleOnClickArticulo = () => {
        if (this.props.dataRubros.rubros.length > 1) {
            this.setState({
                showDialogRubros: true
            })
        } else {
            this.props.history.push({
                pathname: `/Articulo/articuloNuevo/${this.props.data.catalogoCompleto.idCatalogo}`,
                idCatalogo: this.props.data.catalogoCompleto.idCatalogo,
                payloadRubro: this.props.dataRubros.rubros[0].idRubro,
                payloadCatalogoNombre: this.props.data.catalogoCompleto.nombre
            })
        }
    }

    handleOnClickEditar = () => {
        this.props.history.push('/Catalogo/catalogoNuevo/' + (this.props.data.catalogoCompleto.idCatalogo))
    }

    handleOnChangeOrderCatalogoEntradaImagenes = (from, to, idRubro, idSubrubro) => {
        //necesitamos los index de rubro y subrubro para saber de que articulo se trata
        //from y to son los ordenes a cambiar. 

        let catalogo = { ...this.state.catalogo }
        let aux = to

        let indiceRubro = 0
        let indiceSubrubro = 0

        //Conseguimos los index de Rubro y subrubro
        catalogo.listaRubros.map((itemRubro, indexRubro) => {
            itemRubro.listaSubRubros.map((itemSubrubro, indexSubrubro) => {
                if (itemRubro.idRubro === idRubro && itemSubrubro.idSubrubro === idSubrubro) {
                    indiceRubro = indexRubro
                    indiceSubrubro = indexSubrubro
                }
            })
        })

        let ordenFrom = from
        let ordenTo = to

        //Obtenemos los articulos from y to para dsps recorrer el array y hacer el reemplazo
        let array = catalogo.listaRubros[indiceRubro].listaSubRubros[indiceSubrubro].listaArticulos
        let arrayyy = catalogo.listaRubros[indiceRubro].listaSubRubros[indiceSubrubro].listaArticulos
        let articuloFrom = array.filter(function (articulo) {

            return (articulo.orden === ordenFrom
            )
        }) // filtro los articulos y me quedo con el to )

        let articuloTo = array.filter(function (articulo) {

            return (articulo.orden === ordenTo
            )
        }) // filtro los articulos y me quedo con el to )             

        array.map((itemArticulo, index, array) => {
            if (itemArticulo.idArticulo === articuloFrom[0].idArticulo) {
                array[index] = articuloTo[0]
                array[index].orden = ordenFrom
            }

            if (itemArticulo.idArticulo === articuloTo[0].idArticulo) {
                array[index] = articuloFrom[0]
                array[index].orden = ordenTo
            }
        })

        //Info para persistir
        let payload = {}
        payload.idCatalogo = catalogo.idCatalogo
        payload.from = from
        payload.to = to


        this.props.sagaCambiarOrdenCatalogoEntrada(payload)

        //actualizo el catalogo y seteo el nuevo catalogo modificado al estado
        catalogo.listaRubros[indiceRubro].listaSubRubros[indiceSubrubro].listaArticulos = array

        this.props.setCatalogoCompletoAux(catalogo)
    }

    handleCancelButtonRubros = () => {
        this.setState({
            showDialogRubros: false
        })
        //this.props.history.push('/Articulo/articuloNuevo')       
    }

    handleOnClickPublicar = () => {
        //Aqui va la validación para ver si es catalogo unico o que.
        this.setState({
            showDialogPublicar: true
        })
    }

    handleOnOcultar = (idCatalogo) => {

        let payload = {}
        payload.id = idCatalogo

        this.props.sagaSaveOcultarCatalogo(payload)

        Notification.showSuccess('Catalogo Oculto')

        this.setState({
            showDialogOcultar: false,
            showOcultarButton: false,
            showPublicarButton: true,
            showTrasladarButton: true
        })
    }

    handleOnTrasladar = (idCatalogoDesde, idCatalogoHasta) => {
        let payload = {}
        payload.idCatalogoDesde = idCatalogoDesde
        payload.idCatalogoHasta = idCatalogoHasta

        payload.callback = () => this.setState({
            showDialogTrasladar: false,
            showDialogPublicados: false
        }, this.props.history.go(0))

        this.props.sagaTrasladarCatalogo(payload)

        Notification.showSuccess('Catalogo Trasladado')

    }

    handleOnShowPublicados = () => {

        this.setState({
            showDialogTrasladar: false,
            showDialogPublicados: true

        })
    }

    handleCancelPublicadosDialog = () => {

        this.setState({
            showDialogPublicados: false
        })
    }

    handleOnBorrar = (idCatalogo) => {

        let payload = {}
        payload.id = idCatalogo

        payload.callback = () => this.props.history.push('/Catalogo') // Cuando borra el catalogo, redirige.

        this.props.sagaSaveBorrarCatalogo(payload)

        Notification.showSuccess('Catalogo Borrado')


        this.setState({
            showDialogBorrar: false,

        })


    }

    handleOnPublicar = (idCatalogo) => {

        let payload = {}
        payload.id = idCatalogo

        payload.showMenssageInfo = () => { Notification.showSuccess('Catalogo Publicado') }

        this.props.sagaSavePublicarCatalogo(payload)



        this.setState({
            showDialogPublicar: false,

            showPublicarButton: false,
            showTrasladarButton: false,
            showOcultarButton: true
        })
    }


    handleOnCancelarPublicar = () => {
        this.setState({
            showDialogPublicar: false
        })
    }

    handleOnCancelarTrasladar = () => {
        this.setState({
            showDialogTrasladar: false
        })
    }

    handleOnCancelarOcultar = () => {

        this.setState({
            showDialogOcultar: false
        })
    }
    handleOnBack = () => {
        this.props.history.push('/Catalogo/catalogoEdicion/' + this.props.data.catalogos[0].idCatalogo)
    }
    handleOnCancelarBorrar = () => {
        this.setState({
            showDialogBorrar: false
        })
    }


    handleOnCloseStockDisponible = () => {
        this.setState({
            stockDisponible: true
        })
    }

    handleOnCloseCatalogosPublicados = () => {
        this.setState({
            catalogosPublicados: true
        })
    }



    handleOnClickCancelarEliminarArticulo = () => {
        this.setState({

            modalConfirmarEliminacion: false

        })
    }
    handleOnClickcConfirmarEliminarEntrada = (articulo) => {

    }

    handleClickEditarArticulo = (isGenerico, idSuperRubro, idRubro, idArticulo) => {
        if (isGenerico == false) {
            this.props.history.push({
                pathname: '/Articulo/articuloNuevo/0/' + idArticulo,
                payloadRubro: idRubro,

                idArticulo: idArticulo
            })
        }
        else {
            this.props.history.push('/Articulo/articuloGenericoNuevo/' + idSuperRubro + '/' + idRubro + "/" + idArticulo)
        }
    }


    handleOnCloseTrasladado = () => {
        this.setState({

            showDialogPublicados: false
        })
    }

    render() {





        return (
            <div>
                <CatalogoAgregarArticulo

                    {...this.state}
                    catalogo={this.props.data.catalogos}
                    listadoArticulo={this.props.dataArticulos.listadoArticulo !== undefined ? this.props.dataArticulos.listadoArticulo : undefined}
                    handleEnableTrasladar={this.handleEnableTrasladar}
                    fetchMoreArticulos={this.fetchMoreArticulos}
                    hasMoreArticulos={this.state.hasmorearticulos}
                    handleOnClickPublicar={this.handleOnClickPublicar}
                    handleOnClickOcultar={this.handleOnClickOcultar}
                    handleOnClickBorrar={this.handleOnClickBorrar}
                    handleOnClickTrasladar={this.handleOnClickTrasladar}
                    handleOnClickArticulo={this.handleOnClickArticulo}
                    handleOnClickEditar={this.handleOnClickEditar}
                    handleClickEditarArticulo={this.handleClickEditarArticulo}
                    handleOnClickEliminarArticulo={this.handleOnClickEliminarArticulo}
                    handleOnClickAgregarArticulo={this.handleOnClickAgregarArticulo}
                    handleOnClickCancelarEliminarArticulo={this.handleOnClickCancelarEliminarArticulo}
                    handleOnClickcConfirmarEliminarEntrada={this.handleOnClickcConfirmarEliminarEntrada}
                    publicar={this.state.showPublicarButton}
                    ocultar={this.state.showOcultarButton}
                    trasladar={this.state.showTrasladarButton}

                    showDialogPublicar={this.state.showDialogPublicar}
                    showDialogOcultar={this.state.showDialogOcultar}
                    showDialogBorrar={this.state.showDialogBorrar}
                    showDialogTrasladar={this.state.showDialogTrasladar}
                    showDialogPublicados={this.state.showDialogPublicados}
                    showDialogRubros={this.state.showDialogRubros}

                    handleOnPublicar={this.handleOnPublicar}
                    handleOnOcultar={this.handleOnOcultar}
                    handleOnBorrar={this.handleOnBorrar}
                    handleOnTrasladar={this.handleOnTrasladar}

                    handleOnShowPublicados={this.handleOnShowPublicados}
                    handleOnCancelarPublicar={this.handleOnCancelarPublicar}
                    handleOnCancelarOcultar={this.handleOnCancelarOcultar}
                    handleOnCancelarBorrar={this.handleOnCancelarBorrar}
                    handleOnCancelarTrasladar={this.handleOnCancelarTrasladar}
                    handleOnChangeOrderCatalogoEntradaImagenes={this.handleOnChangeOrderCatalogoEntradaImagenes}

                    stockDisponible={this.state.stockDisponible}
                    catalogosPublicados={this.state.catalogosPublicados}

                    handleOnCloseTrasladado={this.handleOnCloseTrasladado}
                    handleOnCloseStockDisponible={this.handleOnCloseStockDisponible}
                    handleOnCloseCatalogosPublicados={this.handleOnCloseCatalogosPublicados}

                    handleCancelPublicadosDialog={this.handleCancelPublicadosDialog}
                    handleCancelButtonRubros={this.handleCancelButtonRubros}
                    currentPage={this.state.page}
                    pageSize={this.state.pageSize}

                    getImgArticulo={this.getImgArticulo}

                    imagenesArticulos={this.props.imagenesArticulos}

                    handleOnSearch={this.handleOnSearch}
                    handleOnBack={this.handleOnBack}
                    mostrarTitleBar={this.state.mostrarTitleBar}
                    validar={this.validar}
                    validarNombre={this.validarNombre}
                    validarCodigo={this.validarCodigo}
                />
            </div>
        )
    }
}



CatalogoAgregarArticulosContainer.propTypes = {
    catalogo: PropTypes.object.isRequired,

}

CatalogoAgregarArticulosContainer.defaultProps = {
    catalogo: []
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...catalogoActions,
        ...articuloActions,
        ...rubrosActions,
        ...sessionActions,
    }, dispatch)
}



function mapStateToProps(state) {
    return {
        data: catalogoDataSelector(state),
        dataPublicados: publicadosSelector(state),
        dataArticulos: articuloDataSelector(state),
        dataRubros: rubrosDataSelector(state),
        usuario: usuarioSelector(state),
        imagenesArticulos: state.catalogoReducer.getIn(["data", "imagenesArticulo"]).toJS()
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogoAgregarArticulosContainer)
